export default __webpack_public_path__ + "static/media/image2.8eb9ae1a.webp";